import { useState } from "react";
import { X, FileText } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export default function QuoteModal({ product, onClose }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/quotes", { product_id: product.product_id, ...form });
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSending(false);
    }
  };

  const inputCls = "w-full h-11 px-4 bg-white border border-[#E6E4DD] rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-amber-600/30 focus:border-amber-600 transition-all";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="quote-modal">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-[#FAF9F5] rounded-3xl shadow-2xl w-full max-w-md p-6 sm:p-8">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 text-neutral-400 hover:text-neutral-700" aria-label="Kapat" data-testid="quote-modal-close">
          <X size={20} />
        </button>
        {done ? (
          <div className="text-center py-6" data-testid="quote-success">
            <div className="w-14 h-14 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center mx-auto mb-4">
              <FileText size={24} />
            </div>
            <h3 className="font-display font-extrabold text-xl mb-2">Teklif Talebiniz Alındı</h3>
            <p className="text-sm text-neutral-500 leading-relaxed">
              "{product.name}" için talebiniz bize ulaştı. Ekibimiz en kısa sürede size dönüş yapacak.
            </p>
            <button onClick={onClose} className="mt-6 h-11 px-8 rounded-full bg-[#121214] text-white text-sm font-semibold hover:bg-amber-600 transition-colors" data-testid="quote-success-close">
              Kapat
            </button>
          </div>
        ) : (
          <>
            <p className="font-mono-ed text-[11px] uppercase tracking-[0.25em] text-amber-700 mb-1">Teklif Al</p>
            <h3 className="font-display font-extrabold text-xl mb-1 pr-8">{product.name}</h3>
            <p className="text-xs text-neutral-500 mb-5">Bilgilerinizi bırakın, size özel fiyat teklifi hazırlayalım.</p>
            <form onSubmit={submit} className="space-y-3">
              <input required minLength={2} placeholder="Ad Soyad" value={form.name} onChange={set("name")} className={inputCls} data-testid="quote-name" />
              <input required type="email" placeholder="E-posta" value={form.email} onChange={set("email")} className={inputCls} data-testid="quote-email" />
              <input required minLength={7} placeholder="Telefon" value={form.phone} onChange={set("phone")} className={inputCls} data-testid="quote-phone" />
              <textarea placeholder="Mesajınız (adet, ölçü, teslim tarihi vb.)" value={form.message} onChange={set("message")} rows={3}
                className="w-full px-4 py-3 bg-white border border-[#E6E4DD] rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-amber-600/30 focus:border-amber-600 transition-all resize-none"
                data-testid="quote-message" />
              <button type="submit" disabled={sending}
                className="w-full h-12 rounded-full bg-amber-600 text-white font-semibold hover:bg-amber-500 transition-colors disabled:opacity-50"
                data-testid="quote-submit">
                {sending ? "Gönderiliyor..." : "Teklif Talebini Gönder"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
